export default __webpack_public_path__ + "static/media/initBlog.9e90a418.png";